<template>
  <div>
    <p class="title line-height-48 hei-24">
      分享卡片样式示意
    </p>
    <div class="block shareBlock">
      <div class="userWrapper">
        <div class="edit-video-grey-circular" />
        小程序名
      </div>
      <div class="title r-mt-6">
        {{ data.title ? data.title : "" }}
      </div>
      <div class="picWrapper">
        <img v-show="data.img" :src="`${data.img}?imageView2/1/w/800/h/640`" />
      </div>
      <div class="bottom">
        <img src="../../../../static/img/miniP.svg" />
        小程序
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style scoped></style>
